<template>
	<div style="background-color:#fffcf7;" class="container">
		<login_user/>
		<headMenu />
		<div
			class="w-100 overflow-hidden"
			:class="(windowWidth<=1000)? 'h-center': ''"
		>
			<div class="col-lg-9 col-md-9 col-sm-12 col-xs-12 float-left p-3">
				<back
					title="رایتینگ آیلتس"
					showBtn='false'
				/>
				<part1
					select="18"
					data-aos="flip-up"
					data-aos-easing="ease-out-cubic"
					data-aos-duration="2000"
				/>
			</div>
			<div class="col-lg-3 col-md-3 float-left"  v-if="windowWidth>1000">
				<part2 select="18" />
			</div>
		</div>
		<footerPage />
	</div>
</template>

<script>
	import userImg from  "../../../../UI/userImg/userImg.vue";
	import headMenu from  "../../../../menu/headMenu.vue";
	import btn from  "../../../../UI/button/btn.vue";
	import part1 from  "./part1.vue";
	import back from  "../../../../UI/back/back.vue";
	import part2 from  "../../../reserved_user_list/part2.vue";
	import footerPage from  "../../../public/home/home_part9.vue";
	import login_user from  "../../../../check/login_user.vue";
	import {error} from  "../../../../assets/library/messege.js";
	export default {
		name: 'self',
		data(){
			return {
				imgurl: window.imgurl,
				baseurl: window.baseurl,
				flds: {ok: false, data: []},
				degrees: [],
				category: [],
				location: [],
				error: error,
			}
		},
		components: {
			btn,
			part1,
			part2,
			footerPage,
			headMenu,
			login_user,
			back,
			userImg,
		},
		props: [],
		computed :{
		},
		mounted(){
			this.$swal.close();
				if(this.$localStorage.get('user')!=null){
					if(this.$localStorage.get('user').username.role==3){
						let text = "دسترسی این بخش مخصوص دانش آموزان و دانشجویان است.";
						this.error(this, text);
						this.$router.push("/reserved/user/list");
					}
				} 
				// this.crmslist();
			},
		methods:{
			// *********************************************************************
			crmslist( THIS = this){
				// if(this.$localStorage.get("user").username.role == 3) {
					window.$.post(this.baseurl+"ai/selecttopic", {
						writing_id: this.$route.params.id
					}, function(D){
						
						if(D.data) {
							THIS.flds = {ok: true, data: D.data};
						}
					
					}, "json");
				// }
			},
		}
			// *********************************************************************
	}
</script>
<style>

</style>
